import React from 'react';
import PropTypes from 'prop-types';

import CheckboxInput from '../Global/Forms/CheckboxInput';
import RadioInput from '../Global/Forms/RadioInput';

const SearchSecondaryFilterOptions = ({ filter, onChange, activeFilters }) => {
  const {
    expected_type: expectedType,
    options,
  } = filter;

  const handleRadioClick = (e, type, checked) => {
    // To allow radio's to be deselected, we need to listen to radio clicks and if the 
    // clicked radio is active, manually fire the onChange function
    // Since React 15.6 onChange events don't fire for inputs that are already selected
    if (checked === true) {
      onChange(e, type);
    }
  };

  return (
    <div>
      {options && options.map((option) => {
        const components = {
          radio: RadioInput,
          checkbox: CheckboxInput,
        };
        let inputType;
        let inputProps;

        switch (expectedType) {
          case `string`: {
            const checked = option === activeFilters[filter.param];
            inputType = `radio`;
            inputProps = {
              label: option,
              value: option,
              name: filter.param,
              checked,
              onClick: e => handleRadioClick(e, expectedType, checked),
            };
            break;
          }
      
          case `array`:
            inputType = `checkbox`;
            inputProps = {
              label: option,
              value: option,
              name: filter.param,
              checked: (activeFilters[filter.param] && activeFilters[filter.param].includes(option)) || false,
            };
            break;
      
          // If there is no expected_type, then we need to treat every object as it's own filter
          // Used for Age and Video filters
          default:
            inputType = `checkbox`;
            inputProps = {
              label: option.display_text,
              value: option.param,
              name: option.param,
              checked: activeFilters[option.param] === true,
            };
        }

        const Input = components[inputType];

        return (
          <div key={inputProps.value} className="form-group">
            <Input 
              onChange={e => onChange(e, expectedType)}
              {...inputProps}
            />
          </div>
        );
      })}
    </div>
  );
};

SearchSecondaryFilterOptions.propTypes = {
  filter: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  activeFilters: PropTypes.object.isRequired,
};

export default SearchSecondaryFilterOptions;


// WEBPACK FOOTER //
// ./library/app/components/Search/SearchSecondaryFilterOptions.js